var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVpsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.67 534.67C110.67 534.67 105.33 529.33 105.33 521.33C105.33 481.07 105.33 158.93 105.33 118.67C105.33 110.67 110.67 105.33 118.67 105.33C158.93 105.33 481.07 105.33 521.33 105.33C529.33 105.33 534.67 110.67 534.67 118.67C534.67 158.93 534.67 481.07 534.67 521.33C534.67 529.33 529.33 534.67 521.33 534.67C440.8 534.67 158.93 534.67 118.67 534.67ZM508 508L508 132L132 132L132 508L508 508Z",
    id: "a54ajONzM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 445.33C200 445.33 194.67 440 194.67 432C194.67 409.6 194.67 230.4 194.67 208C194.67 200 200 194.67 208 194.67C230.27 194.67 408.4 194.67 430.67 194.67C438.67 194.67 444 200 444 208C444 230.27 444 408.4 444 430.67C445.33 438.67 438.67 445.33 432 445.33C387.2 445.33 230.4 445.33 208 445.33ZM417.33 418.67L417.33 221.33L221.33 221.33L221.33 418.67L417.33 418.67Z",
    id: "a3KXeF0kS8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 73.33C168 68 168 25.33 168 20C168 12 173.33 6.67 181.33 6.67C189.33 6.67 194.67 12 194.67 20C194.67 25.33 194.67 68 194.67 73.33C194.67 81.33 189.33 86.67 181.33 86.67C173.33 86.67 168 81.33 168 73.33Z",
    id: "e1WEJjv0p9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.33 73.33C237.33 68 237.33 25.33 237.33 20C237.33 12 242.67 6.67 250.67 6.67C258.67 6.67 264 12 264 20C264 25.33 264 68 264 73.33C264 81.33 258.67 86.67 250.67 86.67C242.67 86.67 237.33 81.33 237.33 73.33Z",
    id: "n6mhC1l8ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.67 73.33C306.67 68 306.67 25.33 306.67 20C306.67 12 312 6.67 320 6.67C328 6.67 333.33 12 333.33 20C333.33 25.33 333.33 68 333.33 73.33C333.33 81.33 328 86.67 320 86.67C312 86.67 306.67 81.33 306.67 73.33Z",
    id: "gVEJU9Upl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 73.33C376 68 376 25.33 376 20C376 12 381.33 6.67 389.33 6.67C397.33 6.67 402.67 12 402.67 20C402.67 25.33 402.67 68 402.67 73.33C402.67 81.33 396 86.67 389.33 86.67C381.33 86.67 376 81.33 376 73.33Z",
    id: "asdV7epVU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.33 73.33C445.33 68 445.33 25.33 445.33 20C445.33 12 450.67 6.67 458.67 6.67C466.67 6.67 472 12 472 20C472 25.33 472 68 472 73.33C472 81.33 465.33 86.67 458.67 86.67C450.67 86.67 445.33 81.33 445.33 73.33Z",
    id: "caDX4dj6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 620C168 614.67 168 572 168 566.67C168 558.67 173.33 553.33 181.33 553.33C189.33 553.33 194.67 558.67 194.67 566.67C194.67 572 194.67 614.67 194.67 620C194.67 628 189.33 633.33 181.33 633.33C173.33 633.33 168 628 168 620Z",
    id: "c5Md73vQg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.33 620C237.33 614.67 237.33 572 237.33 566.67C237.33 558.67 242.67 553.33 250.67 553.33C258.67 553.33 264 558.67 264 566.67C264 572 264 614.67 264 620C264 628 258.67 633.33 250.67 633.33C242.67 633.33 237.33 628 237.33 620Z",
    id: "a1a1WZHcji"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.67 620C306.67 614.67 306.67 572 306.67 566.67C306.67 558.67 312 553.33 320 553.33C328 553.33 333.33 558.67 333.33 566.67C333.33 572 333.33 614.67 333.33 620C333.33 628 328 633.33 320 633.33C312 633.33 306.67 628 306.67 620Z",
    id: "aFeDTDPdw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 620C376 614.67 376 572 376 566.67C376 558.67 381.33 553.33 389.33 553.33C397.33 553.33 402.67 558.67 402.67 566.67C402.67 572 402.67 614.67 402.67 620C402.67 628 396 633.33 389.33 633.33C381.33 633.33 376 628 376 620Z",
    id: "a15ZNwBDd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.33 620C445.33 614.67 445.33 572 445.33 566.67C445.33 558.67 450.67 553.33 458.67 553.33C466.67 553.33 472 558.67 472 566.67C472 572 472 614.67 472 620C472 628 465.33 633.33 458.67 633.33C450.67 633.33 445.33 628 445.33 620Z",
    id: "b2xv1YUZxg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.67 194.67C558.67 194.67 553.33 189.33 553.33 181.33C553.33 173.33 558.67 168 566.67 168C572 168 614.67 168 620 168C628 168 633.33 173.33 633.33 181.33C633.33 189.33 628 194.67 620 194.67C609.33 194.67 572 194.67 566.67 194.67Z",
    id: "a1FTbNYZ0h"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.67 264C558.67 264 553.33 258.67 553.33 250.67C553.33 242.67 558.67 237.33 566.67 237.33C572 237.33 614.67 237.33 620 237.33C628 237.33 633.33 242.67 633.33 250.67C633.33 258.67 628 264 620 264C609.33 264 572 264 566.67 264Z",
    id: "a3h91BpXsT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.67 333.33C558.67 333.33 553.33 328 553.33 320C553.33 312 558.67 306.67 566.67 306.67C572 306.67 614.67 306.67 620 306.67C628 306.67 633.33 312 633.33 320C633.33 328 628 333.33 620 333.33C609.33 333.33 572 333.33 566.67 333.33Z",
    id: "fDeruGQXK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.67 402.67C558.67 402.67 553.33 397.33 553.33 389.33C553.33 381.33 558.67 376 566.67 376C572 376 614.67 376 620 376C628 376 633.33 381.33 633.33 389.33C633.33 396 628 402.67 620 402.67C609.33 402.67 572 402.67 566.67 402.67Z",
    id: "a8B0HykfOA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.67 472C558.67 472 553.33 466.67 553.33 458.67C553.33 450.67 558.67 445.33 566.67 445.33C572 445.33 614.67 445.33 620 445.33C628 445.33 633.33 450.67 633.33 458.67C633.33 465.33 628 472 620 472C609.33 472 572 472 566.67 472Z",
    id: "k34zKbEqZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 194.67C12 194.67 6.67 189.33 6.67 181.33C6.67 173.33 12 168 20 168C25.33 168 68 168 73.33 168C81.33 168 86.67 173.33 86.67 181.33C86.67 189.33 81.33 194.67 73.33 194.67C62.67 194.67 25.33 194.67 20 194.67Z",
    id: "d2rFspEwV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 264C12 264 6.67 258.67 6.67 250.67C6.67 242.67 12 237.33 20 237.33C25.33 237.33 68 237.33 73.33 237.33C81.33 237.33 86.67 242.67 86.67 250.67C86.67 258.67 81.33 264 73.33 264C62.67 264 25.33 264 20 264Z",
    id: "aiL4FHka"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 333.33C12 333.33 6.67 328 6.67 320C6.67 312 12 306.67 20 306.67C25.33 306.67 68 306.67 73.33 306.67C81.33 306.67 86.67 312 86.67 320C86.67 328 81.33 333.33 73.33 333.33C62.67 333.33 25.33 333.33 20 333.33Z",
    id: "cHaXnw2Va"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 402.67C12 402.67 6.67 397.33 6.67 389.33C6.67 381.33 12 376 20 376C25.33 376 68 376 73.33 376C81.33 376 86.67 381.33 86.67 389.33C86.67 396 81.33 402.67 73.33 402.67C62.67 402.67 25.33 402.67 20 402.67Z",
    id: "b7bgmYxt00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 472C12 472 6.67 466.67 6.67 458.67C6.67 450.67 12 445.33 20 445.33C25.33 445.33 68 445.33 73.33 445.33C81.33 445.33 86.67 450.67 86.67 458.67C86.67 465.33 81.33 472 73.33 472C62.67 472 25.33 472 20 472Z",
    id: "g12Upp39E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a54ajONzM",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a54ajONzM",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3KXeF0kS8",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3KXeF0kS8",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1WEJjv0p9",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1WEJjv0p9",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n6mhC1l8ac",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n6mhC1l8ac",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gVEJU9Upl",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gVEJU9Upl",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#asdV7epVU",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#asdV7epVU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#caDX4dj6d",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#caDX4dj6d",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c5Md73vQg",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c5Md73vQg",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1a1WZHcji",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1a1WZHcji",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aFeDTDPdw",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aFeDTDPdw",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a15ZNwBDd",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a15ZNwBDd",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2xv1YUZxg",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2xv1YUZxg",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1FTbNYZ0h",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1FTbNYZ0h",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3h91BpXsT",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3h91BpXsT",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fDeruGQXK",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fDeruGQXK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8B0HykfOA",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8B0HykfOA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k34zKbEqZ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k34zKbEqZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2rFspEwV",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2rFspEwV",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aiL4FHka",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aiL4FHka",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cHaXnw2Va",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cHaXnw2Va",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7bgmYxt00",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7bgmYxt00",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g12Upp39E",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g12Upp39E",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpsIcon);
export default __webpack_public_path__ + "static/media/vps-icon.f34ab278da014218e647040e280ea284.svg";
export { ForwardRef as ReactComponent };